__webpack_require__.p = "https://bmidxbbelgiumnlplprod.netlify.app/";